import { db } from './config';
import {
  collection,
  addDoc,
  getDocs,
  deleteDoc,
  updateDoc,
  doc,
  query,
  where,
  orderBy,
  limit,
  serverTimestamp
} from 'firebase/firestore';

export async function createLandingContent({ title, type = 'text', body = '', mediaUrl = '', sections = [], order = 0, published = true }) {
  const contentData = {
    title: title || '',
    type,
    order: Number(order) || 0,
    published: !!published,
    createdAt: serverTimestamp()
  };

  // Handle different content types
  if (type === 'text' && sections && sections.length > 0) {
    // New format with sections
    contentData.sections = sections;
  } else {
    // Legacy format
    contentData.body = body;
    contentData.mediaUrl = mediaUrl;
  }

  const ref = await addDoc(collection(db, 'landingContent'), contentData);
  return { id: ref.id };
}

export async function listLandingContent() {
  const q = query(collection(db, 'landingContent'), orderBy('order'));
  const snap = await getDocs(q);
  const items = [];
  snap.forEach(d => items.push({ id: d.id, ...d.data() }));
  return items;
}

export async function deleteLandingContent(id) {
  await deleteDoc(doc(db, 'landingContent', id));
  return { success: true };
}

export async function updateLandingContent(id, { title, type = 'text', body = '', mediaUrl = '', sections = [], order = 0, published = true }) {
  const contentData = {
    title: title || '',
    type,
    order: Number(order) || 0,
    published: !!published,
    updatedAt: serverTimestamp()
  };

  // Handle different content types
  if (type === 'text' && sections && sections.length > 0) {
    // New format with sections
    contentData.sections = sections;
  } else {
    // Legacy format
    contentData.body = body;
    contentData.mediaUrl = mediaUrl;
  }

  await updateDoc(doc(db, 'landingContent', id), contentData);
  return { success: true };
}

export async function listApprovedFeedback(max = 10) {
  try {
    // Try the compound query first (requires index)
    const q = query(collection(db, 'feedback'), where('approved', '==', true), orderBy('createdAt', 'desc'), limit(max));
    const snap = await getDocs(q);
    const items = [];
    snap.forEach(d => items.push({ id: d.id, ...d.data() }));
    console.log('listApprovedFeedback result:', items);
    return items;
  } catch (error) {
    console.error('Error in listApprovedFeedback (compound query failed):', error);
    // Fallback: get all feedback and filter client-side
    try {
      console.log('Trying fallback query...');
      const q = query(collection(db, 'feedback'), limit(max * 2)); // Get more to account for filtering
      const snap = await getDocs(q);
      const items = [];
      snap.forEach(d => {
        const data = d.data();
        if (data.approved === true) {
          items.push({ id: d.id, ...data });
        }
      });
      // Sort by createdAt descending (client-side)
      items.sort((a, b) => {
        if (!a.createdAt || !b.createdAt) return 0;
        return b.createdAt.toDate ? b.createdAt.toDate() - a.createdAt.toDate() : 0;
      });
      const result = items.slice(0, max);
      console.log('Fallback query result:', result);
      return result;
    } catch (fallbackError) {
      console.error('Fallback query also failed:', fallbackError);
      throw fallbackError;
    }
  }
}

export async function listAllFeedback(max = 50) {
  const q = query(collection(db, 'feedback'), orderBy('createdAt', 'desc'), limit(max));
  const snap = await getDocs(q);
  const items = [];
  snap.forEach(d => items.push({ id: d.id, ...d.data() }));
  return items;
}

export async function createFeedback({ text = '', author = '', rating = 0, approved = true }) {
  try {
    const feedbackData = {
      text: text || '',
      author: author || '',
      rating: parseFloat(rating) || 0.0,
      approved: !!approved,
      createdAt: serverTimestamp()
    };
    console.log('Creating feedback with data:', feedbackData);
    const ref = await addDoc(collection(db, 'feedback'), feedbackData);
    console.log('Feedback created with ID:', ref.id);
    return { id: ref.id };
  } catch (error) {
    console.error('Error creating feedback:', error);
    throw error;
  }
}

export async function approveFeedback(id, approved = true) {
  await updateDoc(doc(db, 'feedback', id), { approved: !!approved });
  return { success: true };
}

export async function updateFeedback(id, { text, author, rating, approved }) {
  const updateData = {};
  if (text !== undefined) updateData.text = text;
  if (author !== undefined) updateData.author = author;
  if (rating !== undefined) updateData.rating = parseFloat(rating);
  if (approved !== undefined) updateData.approved = !!approved;
  
  await updateDoc(doc(db, 'feedback', id), updateData);
  return { success: true };
}

export async function deleteFeedback(id) {
  await deleteDoc(doc(db, 'feedback', id));
  return { success: true };
} 